"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCategoriesTabPanel = void 0;
const React = require("react");
const react_1 = require("react");
const material_1 = require("@mui/material");
const ProductCategoriesTabPanel = ({ categories }) => {
    const [value, setValue] = (0, react_1.useState)(null);
    const handleChange = (_event, category) => {
        setValue(category);
        document
            .getElementById(category)
            .scrollIntoView({ behavior: "smooth", block: "start" });
    };
    (0, react_1.useEffect)(() => {
        if (!categories) {
            return;
        }
        if (value) {
            return;
        }
        setValue(categories[0].name);
    }, [categories]);
    return (React.createElement(material_1.Tabs, { value: value, onChange: handleChange, variant: "scrollable", scrollButtons: true, allowScrollButtonsMobile: true }, categories.map((category, index) => (React.createElement(material_1.Tab, { label: category.label, key: index, value: category.name })))));
};
exports.ProductCategoriesTabPanel = ProductCategoriesTabPanel;
//# sourceMappingURL=index.js.map